import { CommonStyledComponentProps } from "__utils/type";
import { SuccessButton } from "components/button";
import styled from "styled-components";

export const PersonalInfoTab = styled.div`   
    background: #fff;
    label{
        color: #444845c4;
    }
    .editP{
        font-weight: 500;
    }
    .disabledEdit{
        color: #A9ACA9;
        font-weight: 500;
    }
    input:disabled{
        background: unset !important;
        border: 1px solid #e0e0e0 !important;
    }
    .trans-disabled  input:disabled{
        background: unset !important;
        border: 1px solid #E1E3E0 !important;
        color: #A9ACA9;
        opacity: 0.7;
    }

   .disclaimer-txt a{
        text-decoration: underline;
        color: black;
    }
    h3{
        margin-bottom: 32px;
        font-weight: 500;
        font-size: 20px;
    }
    .accountBtn{
        margin-top: 1rem !important;
    }
    @media screen and (min-width: 767px) {
        padding: 32px;
        .account-btn-wrapper{
            display: flex;
            float: right;
            gap: 20px;
            margin: 20px 0;
            
        }
        .disclaimer-txt .ant-row{
           align-items: center
        }
    }
    @media screen and (max-width: 767px) {
        padding: 32px 16px;
        .account-btn-wrapper{
            display: flex;
            flex-direction: column-reverse;
            margin: 20px 0 60px 0;

        }
    }
   

`;
export const ProfileSubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
    margin-top: 1rem;
    font-size: 14px; 
    float: right;
    @media screen and (min-width: 767px) {
        width: 240px;
    }
`;
